var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-mb-lg" }, [
    _c("div", { staticClass: "q-subheading text-bold text-blue-grey-4" }, [
      _vm._v(_vm._s(_vm.dateFormatted))
    ]),
    _c(
      "div",
      {
        staticClass:
          "bg-white generic-border round-borders overflow-hidden q-mt-sm"
      },
      _vm._l(_vm.timeEntries, function(timeEntry) {
        return _c("list-entry", {
          key: timeEntry.id,
          attrs: { "time-entry": timeEntry, showUser: _vm.showUser }
        })
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }